import React, { ReactNode } from 'react';
import { AriaButtonProps } from '@react-types/button';

export type ButtonVariant = "Primary" | "Neutral" | "Secondary" | "Plain";
export type ButtonSize = "Small" | "Medium" | "Large" | "Tiny";

export const buttonVariant = {
    primary: 'Primary',
    neutral: 'Neutral',
    secondary: 'Secondary',
    plain: 'Plain'
} as const;

export const buttonSize = {
    small: 'Small',
    medium: 'Medium',
    large: 'Large'
} as const;

export interface ButtonProps extends AriaButtonProps {
    ref?: React.ForwardedRef<HTMLButtonElement>;
    id?: string;
    testId?: string;
    autoFocus?: boolean;
    isDisabled?: boolean;
    fillParent?: boolean;
    leftIcon?: () => ReactNode;
    rightIcon?: () => ReactNode;
    isLoading?: boolean;
    variant?: ButtonVariant;
    size?: ButtonSize;
    color?: string;
    onClick?: (_: any) => void;
    className?: string;
    childrenClassName?: string;
    shouldShrinkButtonWhileLoading?: boolean;
    designSystemType?: string;
}

